import React from 'react';

import TariffConnectHOC from 'pages/ProductCard/hoc/TariffConnectHOC';
import TariffConnect from 'pages/ProductCard/Tariff/components/TariffConnect';

import type { ITariffCardReactModel } from '../../types';
import { useYoungTariffLayout } from '../useYoungTariffLayout';
import { FloatingBtnsRow } from './FloatingBtnsRow';
import { FloatingBtnsGroup } from './FloatingBtnsGroup';
import { FloatingConnectButton } from './FloatingConnectButton';
import { IfRenderFloatingWrapper } from './FloatingConnectWrapper';

export const FloatingElements: React.FC<ITariffCardReactModel> = (props) => {
  const {
    isOrderBtnsRow,
    twoOrderBtnsData,
    connectButton,
    esim,
    isConnected,
    availableInShop,
    isArchived,
  } = props.data;

  const isLayoutYoung = useYoungTariffLayout(props.data.layoutType);

  const showOneMoreButton = availableInShop && isConnected && !isArchived && isLayoutYoung;

  return (
    <>
      <FloatingBtnsRow
        connectBtnText={twoOrderBtnsData?.connectBtnText || connectButton}
        shouldRender={Boolean(isOrderBtnsRow && twoOrderBtnsData)}
      />

      <FloatingBtnsGroup
        connectBtnText={twoOrderBtnsData?.connectBtnText || connectButton}
        shouldRender={!isOrderBtnsRow && Boolean(twoOrderBtnsData)}
      />

      <IfRenderFloatingWrapper
        render={() => (
          <TariffConnectHOC>
            <TariffConnect renderYoungConnected />
          </TariffConnectHOC>
        )}
        shouldRender={showOneMoreButton}
      />

      <FloatingConnectButton
        esim={esim}
        isConnected={isConnected}
        isLayoutYoung={isLayoutYoung}
        shouldRender={!twoOrderBtnsData}
      />
    </>
  );
};
